import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadBusinessmodel'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'ビジネスモデルキャンパス、フレームワーク、書き方、目的、記入例'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/download/business-model/'}
        title="ビジネスモデルキャンバス | 資料ダウンロード | Aitria（アイトリア）"
        description="ビジネスモデルキャンバスは、事業全体を俯瞰して見ることができ、優先して取り組むべき課題を洗い出すフレームワークです。新規事業や既存事業の戦略の確認・検証において有効です。"
      />
      <Template />
    </>
  )
}

export default Download
